/* Discount Crystals promotion lifecycle (schema 2 edition): picks what is active and restores ordinary content when nothing is.
   Mirrors the CCM mountWebsite rules: start-inclusive / end-exclusive windows, review clock only when target !== 'live',
   offers/codes/terms only inside the promotion window, PDP prices only for verified scheduled catalog prices. */
(() => {
  if (window.DcPromoMount) return;

  const active = (item, now) => Boolean(item) && item.ready !== false && now >= item.start && now < item.end;

  function mount(edition, options = {}) {
    const doc = options.document || document;
    const sel = Object.assign({
      hero: '[data-cs-hero]',
      nativeHero: '[data-dcp-native-hero]',     // the theme's own homepage hero section
      bar: '[data-cs-bar]',
      nativeBar: '[data-dcp-native-bar]',       // the theme's own announcement bar section
      offer: '[data-cs-offer][data-variant-id]',
    }, options.selectors || {});
    const started = Date.now();
    const clock = () => edition.target !== 'live' && edition.clock ? edition.clock + Math.floor((Date.now() - started) / 1000) : Math.floor(Date.now() / 1000);
    let shown = '';

    const update = () => {
      const now = clock();
      const valid = edition.schema === 2 && edition.store_code === 'dccom' && (edition.target === 'preview' || (edition.target === 'live' && edition.clock === 0)) && Date.now() / 1000 < edition.expires;

      /* hero */
      const feature = valid ? (edition.features || []).find(f => active(f, now)) : null;
      const hero = doc.querySelector(sel.hero);
      const compact = feature ? DcPromo.isCompact(feature.layout) : false;
      doc.querySelectorAll(sel.nativeHero).forEach(n => { n.hidden = Boolean(feature && !compact); });
      if (hero) {
        const inPromo = feature ? active({ start: feature.promotion_start ?? feature.start, end: feature.promotion_end ?? feature.end }, now) : false;
        const key = feature ? JSON.stringify([feature, inPromo]) : '';
        if (key !== shown) {
          shown = key;
          hero.replaceChildren();
          if (feature) {
            const display = { ...feature };
            // Teaser or wind-down: never show offer figures, codes or terms outside the promotion window.
            if (!inPromo) Object.assign(display, { offer_value: '', offer_prefix: '', offer_suffix: '', code: '', terms: '', countdown: feature.deadline_kind === 'custom' && feature.countdown });
            try { DcPromo.render(hero, display, { ...options.render, now }); } catch (error) { hero.hidden = true; doc.querySelectorAll(sel.nativeHero).forEach(n => {n.hidden = false;}); throw error; }
          } else {
            hero.className = ''; hero.removeAttribute('style');
          }
        }
        hero.hidden = !feature;
        if (feature) DcPromo.tick(hero, now);
      }

      /* announcement: an override only while scheduled (or a configured evergreen); otherwise the theme's own bar */
      const message = valid ? (edition.announcements || []).find(a => active(a, now)) : null;
      const override = message ? message : (valid && edition.evergreen ? { text: edition.evergreen, url: edition.evergreen_url || '' } : null);
      const bar = doc.querySelector(sel.bar);
      const showing = bar ? DcPromo.renderBar(bar, override) : false;
      doc.querySelectorAll(sel.nativeBar).forEach(n => { n.hidden = showing; });

      /* PDP: scheduled catalog prices only; discount codes and automatic discounts never touch PDP prices */
      doc.querySelectorAll(sel.offer).forEach(node => {
        const offer = valid ? (edition.offers || []).find(o => active(o, now) && o.offer_type === 'scheduled_prices' && o.currency === node.dataset.currency &&
          (o.variants || []).some(v => String(v.id) === node.dataset.variantId && (edition.target !== 'live' || (o.source_status === 'live' && v.price === Number(node.dataset.catalogPrice))))) : null;
        const key = offer ? JSON.stringify([offer, node.dataset.variantId, node.dataset.catalogPrice]) : '';
        if (node.dataset.offerKey === key) return;
        node.dataset.offerKey = key;
        if (!DcPromo.renderPdpOffer(node, offer, node.dataset.variantId)) node.hidden = true;
      });
      return { feature, message, now };
    };

    update();
    const timer = setInterval(update, 1000);
    const observer = new MutationObserver(records => { if (records.some(r => r.type === 'attributes') || doc.querySelector(`${sel.offer}:not([data-offer-key])`)) update(); });
    observer.observe(doc.body, { childList: true, subtree: true, attributes:true, attributeFilter:['data-variant-id','data-catalog-price'] });
    const stop = () => { clearInterval(timer); observer.disconnect(); };
    window.addEventListener('pagehide', stop, { once: true });
    return { update, stop };
  }

  window.DcPromoMount = { mount };
})();
